module.exports = __webpack_public_path__ + "img/icon-study-highlight.050abdbf.svg";